module.exports = __webpack_public_path__ + "static/media/Laura.0ac95f6c.jpeg";